import { render, staticRenderFns } from "./PerformanceNote.vue?vue&type=template&id=58204965&scoped=true"
import script from "./PerformanceNote.vue?vue&type=script&lang=js"
export * from "./PerformanceNote.vue?vue&type=script&lang=js"
import style0 from "./PerformanceNote.vue?vue&type=style&index=0&id=58204965&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58204965",
  null
  
)

export default component.exports